import person from "../../assets/images/icons/person.svg";
import warning from "../../assets/images/icons/warning.svg";
import steam from "../../assets/images/icons/steam-btn.svg";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { InfoIcon } from "@/shared/icons";

import defStyles from "./SteamLogin.module.scss";
import nomadStyles from "./SteamLogin.nomad.module.scss";

const styles =
  process.env.REACT_APP_BRAND === "nomad" ? nomadStyles : defStyles;
const SteamLogin = () => {
  const { t } = useTranslation(["main", "profile"]);

  return (
    <div className={styles.steam}>
      <div className={styles.title}>Steam Login</div>
      <div className={styles.txt}>
        <InfoIcon />
        {t("profile:steam_is_not_attached")}
      </div>
      <div className={styles.info}>{t("attach_steam")}</div>
      <div className={styles.btn}>
        <NavLink to={`${process.env.REACT_APP_API_URL}/auth/steam`}>
          <button>Steam login</button>
        </NavLink>
      </div>
    </div>
  );
};

export default SteamLogin;
